import {combineReducers} from "redux";
import {authentication} from "./Auth";
import {add_contact} from "./Add_Contact";
import {accounts} from "./Accounts";
import {user_list,addUser,editUser} from "./User";
import {quick_transfer} from "./Quick_Transfer";  
import {account_statement} from "./AccountStatement"; 
import {dashboard} from "./Dashboard"; 
import {header} from "./Header"; 
import {api_details} from "./ApiKeys"; 
import {change_password} from "./Settings";
import {merchantRouteList} from "./UserRole";
import { loader } from "./Loader";
import {prefix} from "./Prefix";
import {bulkUpload} from "./BulkUpload";
import {acl_routes, acl_loaded} from "./Acl_Routes";
import {payoutLinks} from "./PayoutLinks";
import { invoice } from "./Invoice";
import { schedulePayment } from "./SchedulePayment";
import { payout_request } from "./Payout_Request";
const rootReducer = combineReducers({
  auth : authentication,
  add_contact : add_contact,
  accounts : accounts,
  quick_transfer,
  account_statement,
  api_details,
  dashboard,
  header,
  change_password,
  user_list,
  addUser,
  merchantRouteList,
  editUser,
  loader,
  prefix,
  bulkUpload,
  acl_routes,
  acl_loaded,
  payoutLinks,
  invoice,
  schedulePayment,
  payout_request
  
});

export default rootReducer;
